import { useLayoutEffect, type RefObject } from 'react';

/**
 * Puts a scrolling page back at its top when `key` (the page shown in it)
 * changes. Settings and Server settings keep one scroller for every page,
 * so it kept the last page's position: the next page opened scrolled, its
 * first group under the sticky title (QA 2026-10-28). Runs before paint,
 * so the old position never shows.
 */
export function useTopOnChange(ref: RefObject<HTMLElement | null>, key: string): void {
  useLayoutEffect(() => {
    const el = ref.current;
    if (el) el.scrollTop = 0;
  }, [ref, key]);
}
